import React, { useState, useEffect } from 'react';
import { FaArrowDown } from 'react-icons/fa';

const ScrollToFormButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance and hide when in form section
  const toggleVisibility = () => {
    const formElement = document.getElementById('form');
    const formPosition = formElement?.getBoundingClientRect();
    
    // Hide button if we're in the form section
    if (formPosition && formPosition.top <= window.innerHeight && formPosition.bottom >= 0) {
      setIsVisible(false);
      return;
    }

    // Show/hide button based on scroll position
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener when the component mounts
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToForm = () => {
    document.getElementById('form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToForm}
          className="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 z-50 group"
          aria-label="Scroll to form"
        >
          <FaArrowDown className="w-4 h-4 shrink-0" />
        </button>
      )}
    </>
  );
};

export default ScrollToFormButton; 